// frontend/src/index.js
// Purpose: Initialize the React application with Redux and other configurations

// Desired outcome: Set up the application's entry point with appropriate
// providers and configuration to enable Redux state management

// Import dependencies
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './store';
import App from './App';
import './index.css';
import logger from './utils/logger';
import { PortalAuthGuard } from './PortalAuthGuard';

// Set log level based on environment
if (process.env.NODE_ENV === 'development') {
  logger.setLogLevel('DEBUG');
} else {
  logger.setLogLevel('INFO');
}

// Log application startup
logger.info('DART application starting up', {
  env: process.env.NODE_ENV,
  version: process.env.REACT_APP_VERSION || '1.0.0',
  apiUrl: process.env.REACT_APP_API_URL
});

// Get the root element and render the app
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <PortalAuthGuard>
      <Provider store={store}>
        <App />
      </Provider>
    </PortalAuthGuard>
  </React.StrictMode>
);